import { TableCellType } from "@/constants/table/table"
import { WorkflowsTableRow } from "@/types/workflow"
import { ColumnDef } from "@tanstack/react-table"

export const columns: ColumnDef<WorkflowsTableRow>[] = [
  {
    accessorKey: "icons",
    header: "",
    meta: { type: TableCellType.ICONS, className: "p-0 py-2 px-4 w-44 flex flex-row items-center" },
  },
  {
    accessorKey: "nickname",
    header: "Nickname",
    meta: { type: TableCellType.LINK_BUTTON, className: "w-screen" },
  },
  {
    accessorKey: "workflowExecutionCount",
    header: "Executions",
    meta: { type: TableCellType.NUMBER },
  },
  {
    accessorKey: "status",
    header: "Off/On",
    meta: { type: TableCellType.STATUS },
  },
  {
    accessorKey: "actions",
    header: "Actions",
    meta: { type: TableCellType.ACTIONS },
  }
]
